"use strict";

module.exports.default = {
  NODE_ENV: "production",
  ENVIRONMENT: "prod",
  MS_SOCIOLLA_PUBLIC_API_URL: "https://sociolla-api.soco.id",
  MS_SSO_BROKER_API_URL: "https://sso-broker.soco.id",
  MS_SOCO_PUBLIC_API_URL: "https://api.soco.id",
  SOCO_WEB_URL: "https://www.soco.id",
  consoleLogMode: false,
};
